/**
 * Returns a list of exceptions for the sentence beginning research.
 * @returns {Array} The list of exceptions.
 */
export default [
	// Indefinite articles:
	"sebuah", "seorang", "sang", "si",
	// Numbers 1-10:
	"satu", "dua", "tiga", "empat", "lima", "enam", "tujuh", "delapan", "sembilan",
	"sepuluh", "sebelas", "seratus", "seribu", "sejuta", "semiliar", "setriliun",
	// Demonstrative pronouns:
	"ini", "itu", "hal", "ia",
];
